import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import { useSubscribeEBReadings } from '@/features/equipment-browser/subscriptions/use-subscribe-eb-readings';

import {
  activeSequenceValueAtom,
  currentStageValueAtom,
  sequencerEditorConfigAtom,
} from '../state/sequencer-editor.state';

/**
 * Hook to get reactive sequencer reading values.
 * Automatically subscribes to the active sequence and current stage readings.
 *
 * @returns Object containing activeSequenceValue and currentStageValue that update reactively
 */
export const useSequencerReadings = () => {
  const config = useAtomValue(sequencerEditorConfigAtom);

  // Subscribe to the readings
  const subscriptionIds = useMemo(() => {
    const ids = [];
    if (config?.activeSequenceRef?.id) {
      ids.push({
        id: config.activeSequenceRef.id,
        contextKey: 'sequencerEditor',
      });
    }
    if (config?.currentStageRef?.id) {
      ids.push({
        id: config.currentStageRef.id,
        contextKey: 'sequencerEditor',
      });
    }
    return ids;
  }, [config?.activeSequenceRef?.id, config?.currentStageRef?.id]);

  useSubscribeEBReadings(subscriptionIds);

  // Get the values from atoms (will be reactive now that we're subscribed)
  const activeSequenceValue = useAtomValue(activeSequenceValueAtom);
  const currentStageValue = useAtomValue(currentStageValueAtom);

  return {
    activeSequenceValue,
    currentStageValue,
  };
};
